import { Component, effect, OnInit, signal } from '@angular/core';
import { StockCustomService } from '../shared/stockCustom.service';
import { StockCustomItem } from '../models/stock';
import { NotificationService } from '../shared/notification.service';
import { AppModule } from "../app.module";
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-custom-stock',
  imports: [AppModule],
  templateUrl: './custom-stock.html',
  styleUrl: './custom-stock.less'
})
export class CustomStock implements OnInit {


  public stockCustomList = signal<StockCustomItem[]>([]);
  public selectedItem = signal<StockCustomItem | null>(null);
  public newItem = signal<StockCustomItem | null>(null);
  isLoading = signal<boolean>(false);

  constructor(private stockCustomService : StockCustomService, private notification: NotificationService) {  }

  form = new FormGroup({
    stockCode: new FormControl('', Validators.required),
    description: new FormControl('', Validators.required),
    cost: new FormControl(0, [Validators.required, Validators.min(0)]),
    price: new FormControl(0, [Validators.required, Validators.min(0)]),
});

  ngOnInit(): void {
    this.isLoading.set(true);
    this.stockCustomService.getStockCustom().subscribe({
      next: (data) => {
        this.stockCustomList.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        this.notification.handleError('Error loading custom stock: ', err.message);
        this.isLoading.set(false);
      }
    });
  }

  public saveItem() {
    this.isLoading.set(true);

  const item = {
    stockCustomId: this.selectedItem()?.stockCustomId || this.newItem()?.stockCustomId || 0,
    stockCode: this.form.value.stockCode || '',
    description: this.form.value.description || '',
    soh: 0,
    cost: this.form.value.cost || 0,
    price: this.form.value.price || 0,
  };

    if (!item) {
      this.notification.showError('No item selected to save.');
      this.isLoading.set(false);
      return;
    }
    this.stockCustomService.saveStockCustom(item).subscribe({
      next: (data) => {
        if (!this.stockCustomList().find(i => i.stockCustomId === data.stockCustomId)) {
          this.stockCustomList.set([...this.stockCustomList(), data]);
          this.notification.showSuccess('Custom stock item added successfully.');
        } else {
          this.notification.showSuccess('Custom stock item updated successfully.');
          const index = this.stockCustomList().findIndex(i => i.stockCustomId === data.stockCustomId);
          const updatedList = [...this.stockCustomList()];
          updatedList[index] = data;
          this.stockCustomList.set(updatedList);
        }
        this.selectedItem.set(null);
      },
      error: (err) => {
        this.notification.handleError('Error saving custom stock item: ', err.message);

      }, complete: () => {
        this.isLoading.set(false);
        this.form.reset();
      }
    });
  }

  public cancelEdit() {
    this.form.reset();
    this.selectedItem.set(null);
    this.newItem.set(null);
  }

  public addNewItem() {
    const newItem: StockCustomItem = {
      stockCustomId: 0,
      stockCode: '',  
      description: '',
      soh: 0,
      cost: 0,
      price: 0,
    };
    this.newItem.set(newItem);
  }

  public removeItem(item: StockCustomItem) {
    this.isLoading.set(true);
    this.stockCustomService.deleteStockCustom(item.stockCustomId).subscribe({
      next: () => {
        this.notification.showSuccess('Custom stock item removed successfully.');
        this.stockCustomList.set(this.stockCustomList().filter(i => i.stockCustomId !== item.stockCustomId));
      },
      error: (err) => {
        this.notification.handleError('Error removing custom stock item: ', err.message);
      },
      complete: () => {
        this.isLoading.set(false);
        this.form.reset();
      }
    });
  }

  public selectItem(item: StockCustomItem) {
    this.selectedItem.set(item);

    this.form.setValue({
      stockCode: item.stockCode,
      description: item.description,
      cost: item.cost,
      price: item.price,
    });
  }
}
